// <s-sticky-add> shows a compact add-to-cart bar once the main product form has scrolled
// above the viewport, and hides it again when the form is back in view or the page footer
// is reached. Its button submits the main product form, so <s-product-form> handles the add.
class SStickyAdd extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = document.getElementById(this.dataset.target || '');
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.toggleAttribute('data-visible', scrolledPast);
      this.toggleAttribute('inert', !scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-sticky-add')) customElements.define('s-sticky-add', SStickyAdd);
